import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import classNames from 'classnames';
import cuid from 'cuid';
import PropTypes from 'prop-types';
import PageSizes from '@/constants/ui/PageSizes';
import translate from '@/lib/intl/translate';

function PageSizeSelect({
  className = '',
  id = null,
  onChange,
  options = PageSizes,
  value,
  ...rest
}) {
  const [labelId] = React.useState(id || `page-size-select-${cuid()}`);

  return (
    <FormControl
      className={classNames(className, 'flex-row items-baseline')}
      {...rest}
      sx={{
        // <Select> doesn't provide a way to target it's nested <Input> so
        // this will have to do
        '& .MuiInput-root': {
          marginTop: 0,
        },
      }}
    >
      <InputLabel
        id={labelId}
        className="static mr-3 min-w-0 transform-none text-text-primary"
        shrink={false}
      >
        {translate('PER_PAGE')}:
      </InputLabel>
      <Select
        labelId={labelId}
        id={`${labelId}-input`}
        name="pageSize"
        value={value}
        onChange={onChange && onChange}
        variant="standard"
        sx={{
          '&::before': {
            border: 0,
          },
          '&::after': {
            border: 0,
          },
          '&:hover:not(.Mui-disabled):before': {
            border: 0,
          },
        }}
      >
        {options.map((item) => (
          <MenuItem value={item} key={item}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

PageSizeSelect.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.number),
  value: PropTypes.number.isRequired,
};

export default PageSizeSelect;
